(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function rnd(a, b) { return a + Math.random() * (b - a); }

  function initSlider(root) {
    if (root.getAttribute('data-combo-init') === '1') return;
    root.setAttribute('data-combo-init', '1');

    var track   = root.querySelector('.combo-track');
    var slides  = Array.prototype.slice.call(root.querySelectorAll('.combo-slide'));
    var dotsEl  = root.querySelector('.combo-dots');
    var prevBtn = root.querySelector('.combo-nav--prev');
    var nextBtn = root.querySelector('.combo-nav--next');
    var total   = slides.length;
    var index   = 0;
    var delay   = parseInt(root.getAttribute('data-autoplay') || '6000', 10);
    var timer   = null;
    var dots    = [];

    if (!track || !total) return;
    if (total <= 1) root.classList.add('is-single');

    if (total > 1 && dotsEl) {
      slides.forEach(function (slide, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'combo-dot';
        d.setAttribute('aria-label', 'Banner ' + (i + 1));
        d.addEventListener('click', function () { go(i); restart(); });
        dotsEl.appendChild(d);
        dots.push(d);
      });
    }

    function shine(slide) {
      if (reduce || !slide) return;
      var s = slide.querySelector('.combo-shine');
      if (!s) return;
      s.classList.remove('running');
      void s.offsetWidth;
      s.classList.add('running');
    }

    function go(i) {
      index = (i + total) % total;
      track.style.transform = 'translate3d(' + (-index * 100) + '%, 0, 0)';
      slides.forEach(function (s, k) {
        s.setAttribute('aria-hidden', k === index ? 'false' : 'true');
        if (dots[k]) dots[k].classList.toggle('is-active', k === index);
      });
      shine(slides[index]);
    }

    function next() { go(index + 1); }
    function prev() { go(index - 1); }
    function start() { if (total > 1 && delay > 0 && !timer) timer = setInterval(next, delay); }
    function stop() { clearInterval(timer); timer = null; }
    function restart() { stop(); start(); }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });

    var carencia = null, sobreMouse = false, tocando = false;
    function liberar() {
      clearTimeout(carencia); carencia = null;
      if (!sobreMouse && !tocando && !document.hidden) start();
    }
    function segurar(ms) {
      stop();
      clearTimeout(carencia);
      carencia = setTimeout(liberar, ms || 8000);
    }

    root.addEventListener('mouseenter', function () { sobreMouse = true; stop(); });
    root.addEventListener('mouseleave', function () { sobreMouse = false; liberar(); });
    root.addEventListener('pointerdown', function () { segurar(10000); });
    root.addEventListener('touchstart', function () {
      tocando = true; stop();
    }, { passive: true });
    root.addEventListener('touchend', function () {
      tocando = false; segurar(10000);
    }, { passive: true });
    root.addEventListener('touchcancel', function () {
      tocando = false; segurar(10000);
    }, { passive: true });
    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : liberar();
    });

    var x0 = null, dx = 0, arrastou = false;
    root.addEventListener('click', function (e) {
      if (arrastou) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    track.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; dx = 0; arrastou = false; stop();
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (x0 === null) return;
      dx = e.touches[0].clientX - x0;
      if (Math.abs(dx) > 10) arrastou = true;
    }, { passive: true });
    track.addEventListener('touchend', function () {
      if (x0 === null) return;
      if (Math.abs(dx) > 45) { dx < 0 ? next() : prev(); }
      x0 = null; dx = 0;
      setTimeout(function () { arrastou = false; }, 350);
    });

    root.querySelectorAll('.s2-pill').forEach(function (card) {
      var isDestaque = !!card.closest('.is-destaque');
      var accent = getComputedStyle(card).getPropertyValue('--combo-accent-rgb').trim() || '18,201,85';
      var baseBg = isDestaque ? '#fff' : 'rgba(255,255,255,0.07)';
      var spotColor = isDestaque ? 'rgba(' + accent + ', 0.1)' : 'rgba(255, 255, 255, 0.11)';
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        card.style.background =
          'radial-gradient(circle at ' + (e.clientX - rect.left) + 'px ' + (e.clientY - rect.top) + 'px, ' +
          spotColor + ' 0%, transparent 65%), ' + baseBg;
      });
      card.addEventListener('mouseleave', function () {
        card.style.background = baseBg;
      });
    });

    go(0);
    start();
  }

  function initHelloKitty(fx) {
    if (fx.getAttribute('data-hk-init') === '1') return;
    fx.setAttribute('data-hk-init', '1');

    var PINK = fx.getAttribute('data-pink') || '#ff4d9d';
    var INK  = fx.getAttribute('data-ink') || '#111';
    var HEARTS = parseInt(fx.getAttribute('data-hearts') || '8', 10);
    var STARS  = parseInt(fx.getAttribute('data-stars') || '14', 10);
    var DOTS   = parseInt(fx.getAttribute('data-dots') || '18', 10);

    var heart    = '<svg viewBox="0 0 40 40"><path d="M20 34 C8 26 4 18 8 12 C12 6 18 8 20 14 C22 8 28 6 32 12 C36 18 32 26 20 34 Z" fill="' + PINK + '" stroke="' + INK + '" stroke-width="2.5" stroke-linejoin="round"/></svg>';
    var heartOut = '<svg viewBox="0 0 40 40"><path d="M20 34 C8 26 4 18 8 12 C12 6 18 8 20 14 C22 8 28 6 32 12 C36 18 32 26 20 34 Z" fill="#ffd0e3" stroke="' + INK + '" stroke-width="2.5" stroke-linejoin="round"/></svg>';
    var star     = '<svg viewBox="0 0 40 40"><path d="M20 2 C 21 14 26 19 38 20 C 26 21 21 26 20 38 C 19 26 14 21 2 20 C 14 19 19 14 20 2 Z" fill="#fff" stroke="' + PINK + '" stroke-width="1.5" stroke-linejoin="round"/></svg>';
    var starP    = '<svg viewBox="0 0 40 40"><path d="M20 2 C 21 14 26 19 38 20 C 26 21 21 26 20 38 C 19 26 14 21 2 20 C 14 19 19 14 20 2 Z" fill="' + PINK + '"/></svg>';

    var i, el, sz, dur;
    for (i = 0; i < HEARTS; i++) {
      el = document.createElement('div');
      el.className = 'hk-heart';
      el.innerHTML = (i % 2 === 0) ? heart : heartOut;
      sz = 18 + Math.random() * 22;
      dur = 6 + Math.random() * 6;
      el.style.cssText = 'width:' + sz + 'px;height:' + sz + 'px;left:' + (Math.random() * 100) +
        '%;bottom:-30px;animation-duration:' + dur + 's;animation-delay:' + (-Math.random() * dur) + 's';
      fx.appendChild(el);
    }
    for (i = 0; i < STARS; i++) {
      el = document.createElement('div');
      el.className = 'hk-sparkle';
      el.innerHTML = (i % 3 === 0) ? starP : star;
      sz = 14 + Math.random() * 18;
      dur = 1.8 + Math.random() * 2.4;
      el.style.cssText = 'width:' + sz + 'px;height:' + sz + 'px;left:' + (Math.random() * 100) +
        '%;top:' + (Math.random() * 100) + '%;animation-duration:' + dur + 's;animation-delay:' + (-Math.random() * dur) + 's';
      fx.appendChild(el);
    }
    for (i = 0; i < DOTS; i++) {
      el = document.createElement('div');
      el.className = 'hk-dot';
      sz = 3 + Math.random() * 5;
      dur = 1.4 + Math.random() * 2;
      el.style.cssText = 'width:' + sz + 'px;height:' + sz + 'px;left:' + (Math.random() * 100) +
        '%;top:' + (Math.random() * 100) + '%;animation-duration:' + dur + 's;animation-delay:' + (-Math.random() * dur) + 's';
      fx.appendChild(el);
    }
  }

  function initPPG(root) {
    if (root.getAttribute('data-ppg-init') === '1') return;
    root.setAttribute('data-ppg-init', '1');

    var fx = root.querySelector('.ppg-fx');
    if (!fx) return;

    var INK    = root.getAttribute('data-ink') || '#141414';
    var YELLOW = root.getAttribute('data-yellow') || '#ffd23d';
    var COUNT  = parseInt(root.getAttribute('data-sparkles') || '14', 10);
    var PAL = ['#fff', YELLOW, '#ff9ec4'];

    function star(c) {
      return '<svg viewBox="0 0 40 40"><path d="M20 1 C21 14 26 19 39 20 C26 21 21 26 20 39 C19 26 14 21 1 20 C14 19 19 14 20 1 Z" fill="' + c + '" stroke="' + INK + '" stroke-width="1.3" stroke-linejoin="round"/></svg>';
    }

    for (var j = 0; j < COUNT; j++) {
      var sp = document.createElement('div');
      sp.className = 'ppg-tw';
      sp.innerHTML = star(PAL[(Math.random() * PAL.length) | 0]);
      var sz = rnd(12, 26), d = rnd(1.8, 4.2);
      sp.style.cssText = 'width:' + sz + 'px;height:' + sz + 'px;left:' + rnd(2, 98) + '%;top:' + rnd(4, 92) +
        '%;animation-duration:' + d + 's;animation-delay:' + (-rnd(0, d)) + 's';
      fx.appendChild(sp);
    }

    var suffix = root.getAttribute('data-anim-suffix');
    if (!suffix) {
      var holder = root.closest('[data-hbs-slider]');
      suffix = holder ? holder.getAttribute('data-anim-suffix') : '';
    }
    var animBase = 'ppg-wob-' + (suffix ? '%s-' + suffix : '%s');

    root.querySelectorAll('.ppg-char').forEach(function (c, i) {
      var name = animBase.replace('%s', i % 2 ? 'b' : 'a');
      c.style.animation = name + ' ' + (3.8 + Math.random() * 1.2).toFixed(2) + 's ease-in-out infinite';
      c.style.animationDelay = (-Math.random() * 2) + 's';
    });
  }

  function initRuxCanvas(canvas) {
    if (canvas.getAttribute('data-rux-init') === '1') return;
    canvas.setAttribute('data-rux-init', '1');

    var ctx = canvas.getContext('2d');
    var slide = canvas.closest('.combo-slide');
    var CORES = ['#ff3cac', '#38ef7d', '#00d2ff', '#f7971e', '#a855f7', '#facc15', '#fb923c', '#4ade80', '#f472b6', '#34d399', '#60a5fa', '#f87171'];
    var COLS = 22, ROWS = 10, W = 0, H = 0, cells = [], fila = [], lastTs = null, t0 = null;

    function resize() {
      var r = canvas.parentElement.getBoundingClientRect();
      W = canvas.width  = Math.round(r.width)  || canvas.parentElement.offsetWidth;
      H = canvas.height = Math.round(r.height) || canvas.parentElement.offsetHeight;
    }
    function initCells() {
      cells = [];
      for (var i = 0; i < COLS * ROWS; i++) {
        cells.push({ active: false, ttl: 0, maxTtl: 0, opacity: 0, color: '#fff', x: 0, y: 0, w: 0, h: 0, col: i % COLS, row: Math.floor(i / COLS) });
      }
    }
    function spawn() {
      var livres = cells.filter(function (c) { return !c.active; });
      if (!livres.length) return;
      var c = livres[Math.floor(Math.random() * livres.length)];
      var cw = W / COLS, ch = H / ROWS;
      c.active = true;
      c.color = CORES[Math.floor(Math.random() * CORES.length)];
      c.opacity = 0.10 + Math.random() * 0.20;
      c.maxTtl = 80 + Math.random() * 180;
      c.ttl = c.maxTtl;
      c.x = c.col * cw; c.y = c.row * ch;
      c.w = cw * Math.ceil(Math.random() * 3); c.h = ch * Math.ceil(Math.random() * 2);
    }
    function agendar() {
      var n = 5 + Math.floor(Math.random() * 3);
      for (var i = 0; i < n; i++) fila.push(i * (30 + Math.random() * 60));
      setTimeout(agendar, 1200 + Math.random() * 1300 + n * 90);
    }
    function tick(ts) {
      requestAnimationFrame(tick);
      if (slide && slide.getAttribute('aria-hidden') === 'true') { lastTs = null; return; }
      if (!lastTs) { lastTs = ts; t0 = ts; }
      var dt = Math.min(ts - lastTs, 50);
      lastTs = ts;
      var passou = ts - t0;
      while (fila.length && passou >= fila[0]) { fila.shift(); spawn(); }
      ctx.clearRect(0, 0, W, H);
      cells.forEach(function (c) {
        if (!c.active) return;
        c.ttl -= dt;
        var p = 1 - c.ttl / c.maxTtl;
        var fade = p < 0.2 ? p / 0.2 : p > 0.6 ? 1 - (p - 0.6) / 0.4 : 1;
        ctx.save();
        ctx.globalAlpha = c.opacity * fade;
        ctx.fillStyle = c.color;
        ctx.fillRect(c.x, c.y, c.w, c.h);
        ctx.restore();
        if (c.ttl <= 0) c.active = false;
      });
    }

    window.addEventListener('resize', function () { resize(); initCells(); });
    resize(); initCells(); agendar();
    requestAnimationFrame(tick);
  }

  function initAll(scope) {
    var ctx = scope || document;
    ctx.querySelectorAll('[data-hbs-slider]').forEach(initSlider);
    ctx.querySelectorAll('.hk-fx').forEach(initHelloKitty);
    ctx.querySelectorAll('.ppg-banner').forEach(initPPG);
    ctx.querySelectorAll('.rux-canvas').forEach(initRuxCanvas);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
